import { HistoryItem } from "../components/forecast/HoverTable";

export function shortenString(str: string, maxLength: number) {

    if (str.length > maxLength) {
        // Trim the string to the desired length minus 3 (for "...")
        let trimmedStr = str.slice(0, maxLength);

        // Remove any trailing spaces
        trimmedStr = trimmedStr.trimEnd();

        // Add ellipsis after the trimmed string
        return trimmedStr + "...";
    }
    return str;
}
//to add duplicate values
export function aggregateQuantities(data: any) {
    const aggregated = data.reduce((acc: any, item: any) => {
        // If date is already in the accumulator, add the quantity to the existing value
        if (acc[item.date]) {
            acc[item.date] += item.quantity;
        } else {
            // Otherwise, create a new entry
            acc[item.date] = item.quantity;
        }
        return acc;
    }, {});

    // Convert the aggregated object back to the desired format
    const result = Object.keys(aggregated).map(date => ({
        date: date,
        quantity: aggregated[date]
    }));

    // Sort the result array by date
    return result.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
}

export const findObjectWithMaxKeys = (result: any) => {
    // Ensure data?.result is an array and has at least one element
    if (!Array.isArray(result) || result.length === 0) {
        return null;
    }

    // Initialize variables to track the object with the maximum number of keys
    let maxKeysObject = null;
    let maxKeysCount = -1;

    // Iterate through each object in the array
    result.forEach((item: any) => {
        // Count the number of keys in the current object
        const keyCount = Object.keys(item).length;

        // Update the object with the maximum number of keys if necessary
        if (keyCount > maxKeysCount) {
            maxKeysCount = keyCount;
            maxKeysObject = item;
        }
    });

    return maxKeysObject;
};

export const capitalizeHeader = (str: string | undefined | null) => {
    // Check if str is undefined or null
    if (!str) {
        console.warn('capitalizeHeader received an undefined or null string');
        return ''; // or return str if you want to keep it as is
    }
    
    return str
        .split(/[_\s]+/) // Split on underscores or spaces
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export function transformInventoryHistoryObject(inputObject: HistoryItem) {
  
    const resultArray = [];


    for (const [key, value] of Object.entries(inputObject)) {
      resultArray.push({ Date: key, Quantity: value.toLocaleString('en-US') });
    }
  
    return resultArray;
  }


  export function transformSalesHistoryObject(inputArray: any) {
  

        const resultArray = inputArray.map((item: any)=>{
    
            const [key, value] = Object.entries(item)[0]
       
            return { Date: key, Quantity: `${(value as number).toLocaleString('en-US')}` }
        })
        
      
        return resultArray;
      }
  
export const getFileName = ()=>{
    const now = new Date();
    const timestamp = now.toISOString().replace(/[:.-]/g, '');
    return timestamp

}

